"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZTab = void 0;
const React = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ZTab = styled_components_1.default((props) => {
    const { className, badgeColor, badgeValue, label, languageId, ...tabProps } = useLocalizedProps_1.useLocalizedProps(props);
    return (React.createElement(core_2.Tab, Object.assign({ className: className, label: React.createElement(core_1.Badge, { badgeContent: badgeValue, max: 10000, color: "primary", classes: {
                badge: "tab-badge"
            } }, label) }, tabProps)));
}) `
   @media (min-width: 600px) {
      .MuiBadge-badge.tab-badge {
         right: -13px;
      }
   }
   &:hover {
      color: ${props => props.theme["hover-color"]};
   }
   &.MuiTab-root {
      overflow: visible;
      margin: 3px;
      font-family: ${props => props.theme["font-family"]};
      font-weight: bold;
   }
   &.MuiTab-textColorPrimary.Mui-selected {
      color: ${props => props.theme["app-link-color"]};
   }
   .tab-badge {
      background: ${props => {
    const { badgeColor, theme } = props;
    return badgeColor && theme[badgeColor]
        ? theme[badgeColor]
        : badgeColor || theme["input-color"];
}};
      position: absolute;
      right: 2px;
      top: -3px;
      height: 16px;
      font-size: 11px;
      font-family: ${props => props.theme["font-family"]};
   }
`;
//# sourceMappingURL=ZTab.js.map